import type { RequiredEnvVar } from '../config/env'
import { StatePage } from '../ui/states'

export interface ConfigurationMissingProps {
  readonly missing: readonly RequiredEnvVar[]
}

export function ConfigurationMissing({ missing }: ConfigurationMissingProps) {
  return (
    <StatePage illustration="cactus" alert>
      <h1 className="font-heading text-2xl font-semibold text-foreground">
        Configuration missing
      </h1>

      <p className="max-w-prose text-sm text-muted-foreground">
        These required variables are not set:
      </p>

      <ul className="flex w-full list-none flex-col border-t border-border">
        {missing.map((name) => (
          <li
            key={name}
            className="border-b border-border py-2.5 font-mono text-sm text-foreground"
          >
            {name}
          </li>
        ))}
      </ul>

      <p className="max-w-prose text-sm text-muted-foreground">
        Copy <span className="font-mono text-foreground">.env.example</span> to{' '}
        <span className="font-mono text-foreground">.env.local</span>, fill in the values, and
        restart the dev server.
      </p>
    </StatePage>
  )
}
